@use "Styles/includes/variables";
@use "Styles/mixins" as mixins;

:host {
    display: block;
}

// Desktop: card floating over the video player, right-aligned
.poll-overlay--overlay {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 390px;
    z-index: mixins.get-z(generic, 3);
    animation: poll-dissolve-in 100ms ease-in;
}

.poll-overlay__sheet-title {
    font-family: variables.$fontQuaternary;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: mixins.get-color(text, text-primary);
}

@keyframes poll-dissolve-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
